import { h } from "@stencil/core";
export class DcUiLogo {
    render() {
        const logo = 'https://dc-webtoolkit.azureedge.net/images/rexroth_logo_animated.gif';
        const img = (h("img", { key: '6defa757e7fe86e59f0ab42dc2a18bf7a8d71b30', src: logo, alt: this.alt }));
        return this.href ? (h("a", { href: this.href, "aria-label": this.label }, img)) : (img);
    }
    static get is() { return "dc-ui-logo"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dc-ui-logo.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dc-ui-logo.css"]
        };
    }
    static get properties() {
        return {
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "href",
                "reflect": false
            },
            "alt": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "alt",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "label",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=dc-ui-logo.js.map
